/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { loadPeople } from '@linc-technologies/linced-common/utils/load-people';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class UnexplainedRoute extends Route {
  // Services
  @service
  attendanceCodes;

  @service
  store;

  model(params) {
    let dateId = params.date_id;
    let periodId = params.period_id;
    let store = this.store;

    return hash({
      date: store.findRecord('date', dateId),
      period: store.findRecord('timetable/period', periodId),
      records: store.query('attendance/record', { dateId, periodId }),
    });
  }

  // afterModel loads the absent learners, then their caregivers, that the
  // report shows.
  async afterModel({ records }) {
    let unknownCode = this.attendanceCodes.unknown?.code;
    let learnerIds = [];
    for (let record of records) {
      if (record.code === unknownCode) {
        learnerIds.push(record.belongsTo('personId').id());
      }
    }
    await loadPeople(this.store, learnerIds, { includeFormer: true });
    await loadPeople(this.store, this.caregiverIds(learnerIds));
  }

  // caregiverIds gives the caregiver ids of the learners in the store.
  *caregiverIds(learnerIds) {
    for (let id of learnerIds) {
      let contacts = this.store.peekRecord('person', id)?.learner?.contacts;
      if (!contacts) {
        continue;
      }
      for (let contact of contacts) {
        yield contact.caregiverId;
      }
    }
  }
}
